import React from "react";
import { Link } from "react-router-dom";
import { Building2, Store, KeyRound, ChevronRight } from "lucide-react";
import { useAuth } from "../lib/auth";
import { useStores } from "../lib/stores";

const links = [
  {
    to: "/app/stores",
    label: "Stores",
    description: "Manage store locations and switch default store",
    icon: Building2,
    ownerOnly: true,
    testid: "settings-stores",
  },
  {
    label: "Store profile",
    description: "Name, GSTIN, address, theme and billing details",
    icon: Store,
    ownerOnly: true,
    dynamic: true,
    testid: "settings-store-profile",
  },
  {
    to: "/app/settings/change-password",
    label: "Change password",
    description: "Update your login password",
    icon: KeyRound,
    testid: "settings-change-password",
  },
];

export default function Settings() {
  const { user } = useAuth();
  const { activeStoreId } = useStores();
  const isOwner = user?.role === "tenant_owner";

  return (
    <div className="p-6 md:p-10 max-w-2xl mx-auto" data-testid="settings-root">
      <h1 className="font-display font-bold text-3xl">Settings</h1>
      <p className="text-sm mt-1" style={{ color: "var(--text-muted)" }}>
        Account and store configuration
      </p>

      <div className="mt-8 space-y-2">
        {links.map((item) => {
          if (item.ownerOnly && !isOwner) return null;
          const to = item.dynamic
            ? (activeStoreId ? `/app/stores/${activeStoreId}/profile` : "/app/stores")
            : item.to;
          return (
            <Link
              key={item.testid}
              to={to}
              data-testid={item.testid}
              className="card-soft flex items-center gap-4 p-4 hover:shadow-md transition-shadow"
            >
              <div className="w-10 h-10 rounded-md grid place-items-center shrink-0" style={{ background: "var(--surface-tint)", color: "var(--primary)" }}>
                <item.icon size={20} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-medium">{item.label}</div>
                <div className="text-xs mt-0.5" style={{ color: "var(--text-muted)" }}>{item.description}</div>
              </div>
              <ChevronRight size={18} style={{ color: "var(--text-muted)" }} className="shrink-0" />
            </Link>
          );
        })}
      </div>
    </div>
  );
}
